import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-control-sidebar',
    templateUrl: './app-control-sidebar.component.html',
    styleUrls: ['./app-control-sidebar.component.scss'],
    standalone: false
})
export class AppControlSidebarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
